import { Directive, ElementRef, OnInit, Renderer2, Input } from '@angular/core';
import { environment } from '@environments/environment';

@Directive({
  selector: '[stickyReceipt]'
})
export class StickyReceiptDirective {
  @Input() set stickyReceipt(sticky: boolean) {
    this._updateStyles(sticky);
  }
  private _isInternetExplorer = document.documentMode != null;

  constructor(private _hostElement: ElementRef, private _renderer: Renderer2) {}

  private _updateStyles(sticky: boolean): void {
    if (sticky) {
      this._renderer.addClass(this._hostElement.nativeElement, 'sticky-receipt');
    } else {
      this._renderer.removeClass(this._hostElement.nativeElement, 'sticky-receipt');
    }

    this._renderer.setStyle(
      this._hostElement.nativeElement,
      'top',
      environment.production && !this._isInternetExplorer && sticky ? '60px' : '0'
    );
  }
}
